import { eraseCookie, getCookie, setCookie } from './default-modules/default-cookies';
import { add_filter_class } from './default-modules/default-filter';
import { breakpoint_reload_page, comboBox_width } from './default-modules/default-utils';
import { DESKTOP_BREAKPOINT, HTML_WIDTH, RELOAD_PAGE_ON_DESKTOP_BREAKPOINT, TABLET_BREAKPOINT } from './default-modules/default-variables';
import { createLogoutMenuItem } from './project-modules/menu-utils';
import { prodGroupFunctionality, productListFunctionality } from './project-modules/product-list';
import { crossSellingFunctionality, productPageFunctionality } from './project-modules/product-page';
import { initFilterSlider } from './project-modules/project-filter-slider';
import { footer } from './project-modules/project-footer';
import { header, headerDesktop, headerMobile } from './project-modules/project-header';
import { desktopMenu, megaMenu, menu } from './project-modules/project-menu';
import { myAccountPage } from './project-modules/project-myaccount';
import { checkoutPage } from './project-modules/project-checkout';
import { search } from './project-modules/project-search';
import { startpage } from './project-modules/project-startpage';

$(document).ready(function ($) {
  window.getCookie = getCookie;
  window.setCookie = setCookie;
  window.eraseCookie = eraseCookie;

  window.onresize = () => {
    if (RELOAD_PAGE_ON_DESKTOP_BREAKPOINT) {
      breakpoint_reload_page();
    }
    comboBox_width();
  };

  // /* Funktioner som ska anropas en gång */
  productPageFunctionality();
  crossSellingFunctionality();
  productListFunctionality();
  prodGroupFunctionality();
  comboBox_width();
  header();
  menu();
  footer();
  search();
  startpage();
  myAccountPage();
  initFilterSlider();
  checkoutPage();

  if (HTML_WIDTH > DESKTOP_BREAKPOINT) {
    // desktop
    desktopMenu();
    headerDesktop();
    // addMenuTestData();
    megaMenu();
    createLogoutMenuItem('#OpenCartContent', true, true);
  }

  if (HTML_WIDTH <= DESKTOP_BREAKPOINT) {
    // tablet och mobil
    headerMobile();
    createLogoutMenuItem('#NavTree-Vertikal .fw-accordion');
  }

  if (HTML_WIDTH < TABLET_BREAKPOINT) {
    // enbart mobil
  }

  /* Funktioner som ska anropas i loop */
  setInterval(() => {
    add_filter_class();
  }, 200);
});
